import React from 'react'
import { PageLayoutNotFound } from '@ztechapps/webui.page'
import { PageTitle } from '../components/PageTitle'

export const NotFound = () => {
  return (
    <>
      <PageTitle title="Page Not Found" description="The page you're looking for doesn't exist or has been moved." />
      <PageLayoutNotFound />
    </>
  )
}
